import React from 'react'
import Typography from '@mui/material/Typography'
import TextFormField from 'proposals/components/TextFormField'
import InputAdornment from '@mui/material/InputAdornment'
import Box from '@mui/material/Box'

const DynamicFieldBuilder: React.FC<{ field: Field, disabled?: boolean }> = ({ field, disabled }) => {

  switch (field.type) {
    case 'currency':
      return (
        <Box sx={{ mb: 1 }} style={{ marginBottom: 16 }}>
          <TextFormField
            fullWidth
            type={'number'} // currency is a number type
            required={field.isRequired}
            label={field.title}
            name={`dynamicValues.${field.id}`}
            shrink={true}
            disabled={disabled}
            endAdornment={
              <InputAdornment sx={{ ml: 1 }} position="start">
                {field.unitOfMeasure}
              </InputAdornment>
            }
            helperText={field.description ?? ''}
            inputProps={{
              step: 'any'
            }}
          />
        </Box>
      )
    case 'number':
      return (
        <Box sx={{ mb: 1 }} style={{ marginBottom: 16 }}>
          <TextFormField
            fullWidth
            type={field.type}
            required={field.isRequired}
            label={field.title}
            name={`dynamicValues.${field.id}`}
            shrink={true}
            disabled={disabled}
            endAdornment={
              <InputAdornment sx={{ ml: 1 }} position="start">
                {field.unitOfMeasure}
              </InputAdornment>
            }
            helperText={field.description ?? ''}
            inputProps={{
              step: 'any'
            }}
          />
        </Box>
      )
    case 'text':
      return (
        <div style={{ marginBottom: 16 }}>
          <TextFormField
            fullWidth
            type={field.type}
            required={field.isRequired}
            label={field.title}
            shrink={true}
            name={`dynamicValues.${field.id}`}
            disabled={disabled}
            endAdornment={
              <InputAdornment sx={{ ml: 1 }} position="start">
                {field.unitOfMeasure}
              </InputAdornment>
            }
            InputProps={{ endAdornment: <InputAdornment position="end">{field.unitOfMeasure}</InputAdornment> }}
            helperText={field.description ?? ''}
          />
        </div>
      )

    case 'multiline':
      return (
        <div style={{ marginBottom: 16 }}>
          <TextFormField
            fullWidth
            type={field.type}
            required={field.isRequired}
            label={field.title}
            shrink={true}
            name={`dynamicValues.${field.id}`}
            multiline
            disabled={disabled}
            endAdornment={
              <InputAdornment sx={{ ml: 1, alignSelf: 'flex-end', mb: 1.5 }} position="start">
                {field.unitOfMeasure}
              </InputAdornment>
            }
            maxRows={Infinity}
            minRows={4}
            helperText={field.description ?? ''}
          />
        </div>
      )
    case 'title':
      return (
        <div>
          <Typography variant="body2">{field.title}</Typography>
          <Typography color="textSecondary" sx={{ fontSize: 12 }} gutterBottom>
            {field.description}
          </Typography>
        </div>
      )
    default:
      return <div>Unsupported field</div>
  }
}

export default DynamicFieldBuilder
